import React, { useEffect, useState, useRef } from "react";

import * as Material from "@mui/material";

import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";

import "./styles.css";

const ImageImportTool = ({
  size = 48,
  imageMaxWidth=480,
  loading,
  uploading,
  src,
  onLoaded,
  title,
}) => {
  const inputRef = useRef();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({
    unit: "px",
    aspect: 1,
    width: 150,
    height: 150,
  });
  const [preview, setPreview] = useState(src);
  const imageRef = useRef();

  const REF_cropArea = useRef();

  const onCropComplete = (crop) => makeClientCrop(crop);
  const onCropChange = (crop) => {
    setCrop({ ...crop });
  };

  async function makeClientCrop(crop) {
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setPreview(croppedImageUrl);
    }
  }

  function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(preview);
        resolve(window.URL.createObjectURL(blob));
      }, "image/jpeg");
    });
  }

  const handleImageChange = async (event) => {
    setCropModalOpen(true);
    let file = event.target.files[0];

    if (file) {
      if (file.size > 50 * 1024 * 1024) {
        event.target.value = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const base64String = e.target.result;
        event.target.value = null;
        setSelectedImage(base64String);
        setPreview(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div
        className="upload-photo sh-1"
        style={{
          height: `${size}px`,
          width: `${size}px`,
        }}
        onClick={() => {
          inputRef.current?.click();
        }}
      >
        {loading && (
          <Material.Skeleton
            style={{ zIndex: 99, top: 0, left: 0 }}
            variant="rectangular"
            width={210}
            height={60}
          />
        )}

        {preview && <img src={preview || src} alt="Cropped" key={Math.random()} />}

        <div className={" " + (!preview && "empty")}>
          <AddAPhotoIcon
            fontSize="small"
            className="add-photo-icon"
            color="black"
          />
        </div>

        <input
          accept="image/png, image/jpeg, image/jpg"
          ref={inputRef}
          style={{ visibility: "hidden", height: 0, width: 0 }}
          type="file"
          onChange={handleImageChange}
        />
      </div>
      <Material.Modal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
      >
        <Material.Box
          sx={{
            maxWidth: 500,
          }}
          className="upload-photo-modal "
        >
          <h4 className="resize-photo-title">{title}</h4>

          {selectedImage && (
            <div className="image-crop-preview mt-2">
              <ReactCrop
                ref={REF_cropArea}
                aspect={1}
                src={selectedImage}
                crop={crop}
                ruleOfThirds
                onComplete={onCropComplete}
                onChange={onCropChange}
              >
                <img
                  ref={imageRef}
                  src={selectedImage}
                  alt="Crop"
                  width="100%"
                />
              </ReactCrop>
            </div>
          )}
          <div>
            <Material.Button
              variant="contained"
              color="primary"
              style={{ width: "100%" }}
              className="mt-2 px-2 py-2"
              onClick={async () => {
                fetch(preview)
                  .then((response) => response.blob())
                  .then((blob) => {
                    const reader = new FileReader();

                    reader.onload = async (event) => {
                      const base64Image = event.target.result;
                      const file = await resizeAndConvertImage(base64Image, imageMaxWidth);

                      onLoaded(file);
                      setCropModalOpen(false);
                      setPreview(file)
                    };

                    reader.readAsDataURL(blob);
                  })
                  .catch((error) => {
                    console.error("Error fetching Blob data:", error);
                  });
              }}
            >
              Salvar imagem
            </Material.Button>
          </div>
        </Material.Box>
      </Material.Modal>
    </>
  );
};

export default ImageImportTool;

async function resizeAndConvertImage(file, imageMaxWidth) {
  const maxWidth = imageMaxWidth;

  const image = new Image();
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    image.src = file;

    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = image.width;
      let height = image.height;

      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(image, 0, 0, width, height);

      console.log(width, height)

      canvas.toBlob(
        (blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        },
        "image/jpeg",
        0.8 // Ajuste a qualidade da imagem conforme necessário
      );
    };
  });
}
